import { render, staticRenderFns } from "./goodDetail.vue?vue&type=template&id=2c23a220&scoped=true"
import script from "./goodDetail.vue?vue&type=script&lang=js"
export * from "./goodDetail.vue?vue&type=script&lang=js"
import style0 from "./goodDetail.vue?vue&type=style&index=0&id=2c23a220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c23a220",
  null
  
)

export default component.exports